import { useState } from 'react';

import { trans, getResourcePath } from '@spotahome/soyuz/client';
import { HeaderContainer } from '@spotahome/ui-library';

import '@spotahome/landings-common/src/scss/init.scss';

import Hero from '@spotahome/landings-common/src/components/Hero';
import { getReferrerCodeByEmail } from '@spotahome/landings-common/src/graphql/queries/referral';
import graphqlClient from '@spotahome/landings-common/src/graphql/client';

import { getReferrerLink } from '../common/utils';

import HowItWorks from './HowItWorks';
import Form from './Form';
import FormSuccess from './FormSuccess';

const ReferAFriend = () => {
  const [code, setCode] = useState('');

  const [userName, setUserName] = useState('');

  const handleFormData = async formData => {
    const { firstName, lastName, email } = formData;
    setUserName(firstName);
    const referralCodeResponse = await getReferrerCodeByEmail(graphqlClient())({
      input: {
        email,
        lastName,
        firstName
      }
    });
    const { referralCode } = referralCodeResponse.data.getReferrerCodeByEmail;
    setCode(referralCode);
  };

  return (
    <>
      <Hero
        menu={
          <HeaderContainer
            login={false}
            showMobileMenu={false}
            links={{
              home: false,
              listYourProperty: false,
              howItWorks: false,
              favorites: false
            }}
          />
        }
        title={trans('external.refer_a_friend.hero.title')}
        subtitle={trans('external.refer_a_friend.hero.subtitle')}
        size="big"
        colorTitle="dark"
        colorSubtitle="dark"
        isRowAlignContent
        className="hero__wrapper--fit"
        image={getResourcePath(
          '/images/refer-a-friend/referral-illustration.svg'
        )}
      />
      <div className="form__section__wrapper">
        {code ? (
          <FormSuccess
            code={code}
            link={code ? getReferrerLink({ code }) : ''}
            userName={userName}
          />
        ) : (
          <Form onFormSubmission={handleFormData} />
        )}
      </div>
      <HowItWorks />
    </>
  );
};

export default ReferAFriend;
